// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1vSEc","item":"PaymentsMobile_item__4dE0b","label":"PaymentsMobile_label__1CxMX","amount":"PaymentsMobile_amount__5qcv6"};